import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '../app/store'
import BasicModalWindow from './BasicModalWIndow'
import { useDispatch } from 'react-redux'
import { handleCloseElementQuickPreview } from '../features/admin/adminPagesSlice'
import AlertElement from './AlertElement'
import { useLocation } from 'react-router-dom'
import { useReturnCurrentUser } from '../features/user/userSlice'

export default function QuickElementPreview() {

    const dispatch = useDispatch()

    const location = useLocation()
    const [prevPath, setPrevPath] = useState<string>(location.pathname)

    const {
        open,
        appClass,
        title,
        actionButtons,
        elementId,
        enableCustomContent,
        customContent,
        showTitle
    } = useSelector((state: RootState) => state.adminPages.quickPreview )

    const handleClose = () => handleCloseElementQuickPreview(dispatch)

    const appInstance = typeof appClass === "function" ? appClass() : appClass

    useEffect(() => {
        if (prevPath !== location.pathname){

            handleCloseElementQuickPreview(dispatch)
            setPrevPath(location.pathname)
        }
    }, [location.pathname])

    /**
     * Render content
     */
    const renderContent = () => {
        if (enableCustomContent){
            if (customContent){
                return customContent(elementId)
            }
        }

        return elementId ? appInstance.quickPreview(elementId) : <AlertElement type="error" message="Element ID is not specifed" />
    }

    return(
        <BasicModalWindow
            shown={open}
            title={showTitle ? title : ""}
            handleClose={handleClose}
            size="lg"
            actionButtons={actionButtons ? actionButtons : []}
            actionButtonsBottom
        >
            <div className="quick-element-preview-content">
                {renderContent()}
            </div>
        </BasicModalWindow>
    )
}